<template>
    <div class="choice">
        <!-- <Tinymce :height="400" v-model="content"></Tinymce> -->
        <el-form ref="questionform" :model="form" label-width="80px">
            <el-form-item label="名称" prop="title">
                <el-input v-model="form.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="题型说明" prop="description">
                <el-input type="textarea" v-model="form.description" placeholder="请输入题型说明"></el-input>
            </el-form-item>
            <el-form-item label="原文" prop="body">
                <Tinymce :height="400" v-model="form.body"></Tinymce>
            </el-form-item>
            <el-divider content-position="left">添加试题</el-divider>
            <div v-for="(item, index) in form.options" :key="index">
                <el-form-item :label="`问题（${index + 1}）`" :prop="`options.${index}.question`"> 
                    <el-input style="width: 70.2%;" v-model="form.options[index].r_answer" placeholder="正确答案"></el-input>
                    <template>
                    <el-popconfirm
                    confirm-button-text='是的'
                    cancel-button-text='取消'
                    icon="el-icon-info"
                    icon-color="red"
                    title="是否确认删除？"
                    @confirm="delQuestion(index)"
                    >
                        <el-button slot="reference" size="small" style="margin-left: 10px;color: #F56C6C;" type="text">删除</el-button>
                    </el-popconfirm>
                    </template>
                </el-form-item>

                <el-form-item label="" :prop="`options.${index}.analysis`">
                    <el-input style="width: 70%;" v-model="form.options[index].analysis" type="textarea" placeholder="答案解析"></el-input>
                </el-form-item>
            </div>
            <div style="display: inline-block;width: 100%;text-align: center;">
                <el-button size="small" @click="open" type="primary" class="el-icon-edit" plain> 保存</el-button>
                <el-button size="small" @click="pushQuestion" class="el-icon-plus" type="primary"> 继续出题</el-button>
            </div>
            
        </el-form>
    </div>
</template>
<script>
import Tinymce from '../Tinymceedit.vue'
export default {
    name:'Word',
    props:{
        question_type:{
            type:Number,
            default:0
        }
        
    },
    components: {
        Tinymce,
    },
    data(){
        return{
            form:{
                body:'',
                title:'',
                description:'',
                options:[
                    {
                        analysis:'',
                        r_answer:''
                    }
                ]
            }
        }
    },

    methods:{
        pushQuestion(){
            var params = {
                        analysis:'',
                        r_answer:''
                    }
            this.form.options.push(params)
        },

        delQuestion(index){

            var question = this.form.options

            question.splice(index, 1)
            
        },
        clear(){
            this.$refs.questionform.resetFields();
            this.form.options = [
                    {
                        analysis:'',
                        r_answer:''
                    }
                ]
        },
        open() {
            this.$confirm('提交前请确认是否添加完成?', '提示', {
                confirmButtonText: '确认添加完成',
                cancelButtonText: '继续添加',
                type: 'warning'
            }).then(() => {

                var params = this.form
                params.type = this.question_type
                this.$emit('create',this.form)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },

        // create(){
        //     createQuestion
        // }

    }
}
</script>
<style scoped>
.choice{
    margin-top: 20px;
}
.choice >>> .el-input{
    width: 70%;
}
.choice >>> .el-textarea{
    width: 70%;
}
.choice >>> .el-divider{
    width: 70%;
}
.option{
    width: 30px;
    height: 30px;
    display: inline-block;
    border: 1px solid #DCDFE6;
    text-align: center;
    line-height: 30px;
    border-radius: 50px;
    margin-right: 10px;
    color: #409EFF;
    font-size: 12px;
}
.ic{
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
}
</style>